/**Import react section */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router-dom'

/**Import actions section */
import {
	addChecklistResponse,
	addPossibleSeriesInService,
	deleteSerieInSerivce,
	getChecklistFromService,
	getPossibleService,
	setChecklistApplicability
} from '../../store/services/serviceActions'

/**Import components section */
import Toaster from '../common/Toaster'
import DesktopView from './components/DesktopView'
import { isNullOrEmpty } from '../../store/helpers/StringHelper'
import { loadAllRetailss } from '../../store/retails/retailsActions'
import { loadInternalUsers } from '../../store/users/UsersActions'
import { loadAllSalesRepresentatives } from '../../store/salesrepresentatives/salesRepresentativesActions'

const Index = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const match = useRouteMatch()
	const token = match.params.token // Obtener el token de la URL

	const userProfile = useSelector((state) => (state.session.get('profile') ? state.session.get('profile').toJS() : null))
	const service = useSelector((state) => (state.services.get('service') ? state.services.get('service').toJS() : null))
	const isLoading = useSelector((state) => state.services.get('isLoading'))
	const isSaving = useSelector((state) => state.services.get('isSavingService'))
	const checklists = useSelector((state) => (state.services.get('checklists') ? state.services.get('checklists').toJS() : null))
	/**Local state section */
	const [currentStep, setCurrentStep] = useState(null)
	// const [addedSeries, setAddedSeries] = useState([])
	const [selectedSerie, setSelectedSerie] = useState(null)
	const [checklistData, setChecklistData] = useState(null)
	const [initialLoadComplete, setInitialLoadComplete] = useState(false)

	const [toaster, setToaster] = useState({
		open: false,
		variant: null,
		message: null
	})

	// Cargar datos necesarios
	useEffect(() => {
		dispatch(loadAllRetailss())
		dispatch(loadInternalUsers())
		dispatch(loadAllSalesRepresentatives(null, 1000))
	}, [dispatch])

	/**
	 * Function to add equipment
	 * @param {*} series
	 */
	const onAddSeries = (series) => {
		return dispatch(addPossibleSeriesInService(token, series))
			.then(() => {
				// dispatch(getPossibleService(token))

				return Promise.resolve()
			})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error) ? error : 'An error to add series in service',
					variant: 'warning'
				})
				return Promise.reject()
			})
	}

	const onChecklistResponse = (questionToken, answer, optionToken) => {
		let data = {
			ServiceToken: token,
			QuestionToken: questionToken,
			OptionToken: optionToken,
			OpenAnswer: answer
		}
		return dispatch(addChecklistResponse(data))
			.then(() => {
				// dispatch(getPossibleService(token))

				return Promise.resolve()
			})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error) ? error : 'An error to add checklist response',
					variant: 'warning'
				})
				return Promise.reject()
			})
	}

	const onSetChecklistApplicability = (isChecklistApplicable) => {
		return dispatch(setChecklistApplicability(token, isChecklistApplicable))
			.then(() => {
				// dispatch(getPossibleService(token))

				return Promise.resolve()
			})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error) ? error : 'An error to set checklist applicability',
					variant: 'warning'
				})
				return Promise.reject()
			})
	}

	const onDeleteSerieFromService = (equipmentToken) => {
		dispatch(deleteSerieInSerivce(token, equipmentToken)).catch(() => {
			console.error('Error to delete service')
		})
	}

	// Cargar el servicio inicial
	useEffect(() => {
		if (token && !initialLoadComplete) {
			dispatch(getPossibleService(token))
				.then((data) => {
					setInitialLoadComplete(true)
				})
				.catch((error) => {
					console.error('Error loading service:', error)
					setCurrentStep(1) // Fallback a step 1 en caso de error
					setInitialLoadComplete(true)
					setToaster({
						open: true,
						variant: 'error',
						message: 'Error al cargar el servicio'
					})
				})
		}
	}, [dispatch, token, initialLoadComplete])

	useEffect(() => {
		dispatch(getChecklistFromService())
	}, [dispatch])

	useEffect(() => {
		if (service && currentStep === null) {
			// Inicializar currentStep
			if (service.ActualStep) {
				setCurrentStep(service.ActualStep)
			} else {
				setCurrentStep(1)
			}
		}
	}, [service, currentStep])

	const onChangeLocation = (location) => history.push(location)

	console.log('serviceJS=>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>><', service)
	console.log('isLoading=>>>>>>>>>>>>>>>>>>>', isLoading)
	console.log('currentStep=>>>>>>>>>>>>>>>>>>>', currentStep)
	console.log('checklists=>>>>>>>>>>>>>>>>>>>', checklists)
	if (isLoading) return <div>Loading...</div>
	return (
		<>
			<DesktopView
				//functions props
				onChangeLocation={onChangeLocation}
				onAddSeries={onAddSeries}
				onDeleteSerieFromService={onDeleteSerieFromService}
				onSetChecklistApplicability={onSetChecklistApplicability}
				// onNavigateToAddSerie={onNavigateToAddSerie}
				onChecklistResponse={onChecklistResponse}
				userProfile={userProfile}
				service={service}
				token={token}
				// State props
				currentStep={currentStep}
				setCurrentStep={setCurrentStep}
				// addedSeries={addedSeries}
				// setAddedSeries={setAddedSeries}
				selectedSerie={selectedSerie}
				setSelectedSerie={setSelectedSerie}
				checklistData={checklistData}
				setChecklistData={setChecklistData}
				initialLoadComplete={initialLoadComplete}
				//object props
				checklists={checklists}
				//bool props
				isSaving={isSaving}
			/>
			<Toaster toasterOptions={toaster} onClose={() => setToaster({ open: false })} />
		</>
	)
}

export default Index
